import React, {Component} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {findDOMNode} from 'react-dom';

import template from './../../templates/Stones/MaterialsFilters.rt';
import * as Misc from "../../misc";
import * as actionTypes from './../../actions';

const mapStateToProps = (state, ownProps) => {
  if (ownProps.filters) {
    return {
      version: 3,
      items: ownProps.filters.items,
      checked: ownProps.filters.checked
    }
  }
  if(!ownProps.filterName) {
    return {
      version: 1,
      items: ownProps.filterGroup
        ? ownProps.filterGroup.values
        : (ownProps.type === 'materials'
          ? state.stones.materialsFilters.toJS()
          : state.stones.colorsFilters.toJS()),
      checked: (ownProps.type === 'materials'
        ? state.stones.materialFilter.toJS()
        : state.stones.colorFilter.toJS())
    }
  } else {
    let filterGroups = _.first(state.stonesV2.usedFilterGroups.filter(f => f.name === ownProps.filterName));
    return {
      version: 2,
      items: filterGroups && filterGroups.values,
      checked: filterGroups && filterGroups.values && filterGroups.values.filter(f => _.findIndex(state.stonesV2.selectedFilters, f.id) >= 0)
    }
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleFilterClick: (item, type) => ownProps.handleFilterClick
      ? ownProps.handleFilterClick(item, type)
      : dispatch(actionTypes.addMaterialsFilter(item, type))
  }
}

class MaterialsFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded,
      isMarkupExpanded: false
    }
  }

  componentDidMount() {
    if (this.props.button) {
      document.getElementById(this.props.button).addEventListener('click', (e) => {
        this.setState({expanded: !this.state.expanded}, () => {
          findDOMNode(this).focus();
        });
      });
    }
  }

  close = (e) => {
    Misc.ignoreDefault(e);
    this.setState({expanded: false});
  }

  toggleMarkupView = (e) => {
    Misc.ignoreDefault(e);
    this.setState({isMarkupExpanded: !this.state.isMarkupExpanded});
  }

  handleBlur = () => {
    this.setState({expanded: false});
  }

  render() {
    return template.apply(this);
  }
}

MaterialsFilters.displayName = 'Materials Filter';

MaterialsFilters.propTypes = {
  expanded: PropTypes.bool.isRequired,
  button: PropTypes.string, // not required, can be shown inside another container, without drop-down button
  type: PropTypes.string.isRequired,
  isManual: PropTypes.bool
};

const MaterialsFiltersContainer = connect(mapStateToProps, mapDispatchToProps)(MaterialsFilters);

export {
  MaterialsFilters,
  MaterialsFiltersContainer
}

